import React from 'react'
import ClientFormContainer from './ClientFormContainer'

export default function ClientFormScreen() {
    return <ClientFormContainer />
}
